module.exports = __webpack_public_path__ + "static/FAQ-banner3-4d186d1a27ac688ad67c466648a4b1e3.jpg";